import { SectionRequest } from "@/types/SectionRequest";

export const filterRequests = (sectionRequests:SectionRequest[])=>{
    const pageId = window.location.search.substring(1)
    if(!pageId||pageId===""){
        return sectionRequests
    }
    const filtered = sectionRequests.filter(r=>r.pageId===pageId)
    return filtered
}